<template>

    <div>

        <!-- <Navbar title="" :back="true" backurl="" /> -->
        <div class="page">

            <div>
                <img src="@/assets/package/detail-h1.png" alt="">
            </div>

            <div class="content">
                
                <div class="row row-2 row-3">
                    <div class="row-center">
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>5</b>
                                <div>
                                    <div class="number">x2</div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>
                        </div>
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>3</b>
                                <div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>
                        </div>
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>2</b>
                                <div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>
                        </div>
                    </div>

                    <div class="row-center">
                        <b style="margin-top: 28px;">停车立减券包</b>
                    </div>

                </div>
                <div v-if="coupon.id == 9" class="row row-2 row-4">

                    <div class="row-center">

                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>10</b>
                                <div>
                                    <div class="number">x1</div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>

                        </div>
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>5</b>
                                <div>
                                    <div class="number">x5</div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>
                        </div>
                    </div>

                    <div class="row-center">
                        <b style="margin-top: 28px">车位优选券包</b>
                    </div>
                </div>

                <div v-if="coupon.id == 10" class="row row-2 row-5">

                    <div class="row-center">
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>10</b>
                                <div>
                                    <div class="number">x1</div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>

                        </div>
                        <div class="row-c ">
                            <div class="row-c-t">
                                <b>5</b>
                                <div>
                                    <div class="number">x5</div>
                                    <span>元</span>
                                </div>
                            </div>
                            <div class="ticket">立减券</div>
                        </div>
                    </div>
                </div>

                <div class="buy" @click="buyNow">
                    <img src="@/assets/package/buy.png" alt="">
                </div>

                <div class="rule">
                    <div v-show="coupon.parking_voucher_rules" class="rule-item ">
                        <div class="rule-tip">
                            停车券使用规则
                        </div>
                        <div class="rule-text rule-text-top">
                            <div style="white-space: pre-wrap;" v-html="coupon.parking_voucher_rules"></div>
                        </div>
                    </div>
                    <div v-show="coupon.parking_space_rules" class="rule-item">
                        <div class="rule-tip">
                            车位券使用规则
                        </div>
                        <div class="rule-text">

                            <!-- <p>1. <span class="rule-link"><img src="@/assets/package/hand-l.png" alt="">
                                <a target="_blank" href="https://www.jslife.com.cn/jtc-uni-h5/index.html#/pages/search-stall/search-stall">
                                    查看可适用车场
                                </a>
                                <img src="@/assets/package/hand-r.png" alt=""></span>
                            </p> -->
                            
                        
                            <div style="white-space: pre-wrap;" v-html="coupon.parking_space_rules"></div>
                        </div>
                    </div>
                    <div v-show="coupon.charging_voucher_rules" class="rule-item">
                        <div class="rule-tip">
                            充电券使用规则
                        </div>
                        <div class="rule-text">

                            <!-- <p>1. <span class="rule-link"><img src="@/assets/package/hand-l.png" alt="">
                                <a target="_blank" href="https://www.jslife.com.cn/jtc-h5/coupon/coupon-list.html#ApplyStations/CPPMpTgW6KTVqbkVQyBw">
                                    查看可适用电站
                                </a>
                                <img src="@/assets/package/hand-r.png" alt=""></span>
                            </p> -->
                            
                            <div style="white-space: pre-wrap;" v-html="coupon.charging_voucher_rules"></div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="adtip">广告</div>
        </div>
    </div>


</template>

<script>
import Navbar from '../../components/navbar.vue';
import * as api from '../../http-service/api-client';

export default {
    name: 'HomeDetailView',
    components: {
        Navbar
    },
    data(){
        return {
            placeChannel: 'IBMH', // 广发银行
            type: 1,
            coupon: {},
            isSubmit: true,
        }
    },
    methods: {
        packageDetail: function(){
            api.couponsPackageDetail(this.$route.query.id).then(result => {
                if (result.data.code == 200) {
                    this.coupon = result.data.data
                    // console.log(this.coupon)
                }
            })
        },
        buyNow: function(){
            if (this.isSubmit === false) {
                console.log('不可重复提交')
                return false
            }
            this.isSubmit = false

            let str = '您选购的权益将发放至手机尾号为 xxxx 的“捷停车”账号，支付成功后，您可使用该手机号登录“捷停车”小程序使用或查看您的权益。'
            let userInfo = sessionStorage.getItem('userInfo')
            let mobile = ''
            let lastFour = ''
            if (userInfo) {
                userInfo = JSON.parse(userInfo)
                mobile = userInfo.mobile
                lastFour = mobile.slice(-4)
                str = str.split('xxxx').join(lastFour);
            }
            
            alert(str)

            var args = {
                packageId: this.$route.query.id,
                placeChannel: this.placeChannel
            }
            let result = {}
            api.createOrder(args).then(res => {
                result = res.data
                console.log(result)
                if (result.code != 200) {
                    alert(result.msg)
                    return false;
                }  
                this.cgbPay(result)
            })
            
        },
        cgbPay: function(result){
            let data = {
                keyCiphertext: result.data.keyCiphertext,
                textToDecrypt: result.data.textToDecrypt,
                signature: result.data.signature,
                appId: result.data.appId,
                businessType: "06",
                // isCallback: false
            }
            AlipayJSBridge.call('cgbPay', data,
                (res) => {
                    this.isSubmit = true
                    if (res.respCode == '0000') {
                        alert(res.respMsg)
                    } else {
                        var msg = res.errorMsg ? res.errorMsg : res.respMsg
                        alert(msg)
                    }
                }
            )
        }
    },
    created(){
        this.packageDetail()
    }

}

</script>
<style lang="stylus" scoped>

.page {
    background linear-gradient(#ffddc0, #fff0e2)
    overflow hidden
}

.content {
 
  border-radius: 40px;
  background-color: rgb(255, 255, 255);
    margin 26px
    margin-top 0
    padding 36px 10px
    padding-bottom 0
}

.buy {
    margin auto
    margin-top 48px
    text-align center
    img {
        width 478px
    }
}

.rule {
    padding 18px
}
.rule-item  {
    padding-bottom 20px
}
.rule-tip {
    width 216px
    height 35px
    background url(@/assets/package/rule.png) center / contain no-repeat
    font-weight bold
    font-size 24px
    color #e54b18
    text-align center
    line-height 35px
    
}

.rule-text {
    color: #4c4948;
    font-size 24px;
    line-height 42px;
    padding 14px
    img {
        height 28px
    }
}

.rule-link {
    
    color: #e54b18;
    text-decoration underline    
    a {
        color: #e54b18;
    }
}
 

</style>

<style lang="stylus" scoped src="./style.styl"></style>